export const testimonialsData = [
  {
    key: "1",
    IMAGE: "customer-01.jpg",
    CUSTOMER: "Andrew Simons",
    RATING: "(5.0)",
    REVIEW: "The rental was spotless, great host!",
    CREATEDDATE: "24 Jan 2025",
  },
  {
    key: "2",
    IMAGE: "customer-02.jpg",
    CUSTOMER: "David Steiger",
    RATING: "(4.0)",
    REVIEW: "Good stay, but Wi-Fi was slow.",
    CREATEDDATE: "19 Dec 2024",
  },
  {
    key: "3",
    IMAGE: "customer-03.jpg",
    CUSTOMER: "Virginia Phu",
    RATING: "(5.0)",
    REVIEW: "Loved everything about this place!",
    CREATEDDATE: "11 Dec 2024",
  },
  {
    key: "4",
    IMAGE: "customer-04.jpg",
    CUSTOMER: "Walter Hartmann",
    RATING: "(3.0)",
    REVIEW: "Needs better maintenance service.",
    CREATEDDATE: "29 Nov 2024",
  },
  {
    key: "5",
    IMAGE: "customer-05.jpg",
    CUSTOMER: "Andrea Jermaine",
    RATING: "(4.0)",
    REVIEW: "Nice apartment, but check-in was slow.",
    CREATEDDATE: "03 Nov 2024",
  },
  {
    key: "6",
    IMAGE: "customer-06.jpg",
    CUSTOMER: "Dennis Eckhardt",
    RATING: "(5.0)",
    REVIEW: "Highly recommend, everything was perfect!",
    CREATEDDATE: "31 Oct 2024",
  },
  {
    key: "7",
    IMAGE: "customer-07.jpg",
    CUSTOMER: "Dennis Eckhardt",
    RATING: "(5.0)",
    REVIEW: "Highly recommend, everything was perfect!",
    CREATEDDATE: "31 Oct 2024",
  },
  {
    key: "8",
    IMAGE: "customer-08.jpg",
    CUSTOMER: "Lan Adams",
    RATING: "(3.0)",
    REVIEW: "Decent experience, but expected better service.",
    CREATEDDATE: "15 Oct 2024",
  },
  {
    key: "9",
    IMAGE: "customer-09.jpg",
    CUSTOMER: "Ann Crump",
    RATING: "(5.0)",
    REVIEW: "Great place for work trips, fast Wi-Fi!",
    CREATEDDATE: "26 Sep 2024",
  },
  {
    key: "10",
    IMAGE: "customer-10.jpg",
    CUSTOMER: "Julie Black",
    RATING: "(4.0)",
    REVIEW: "Affordable and close to university.",
    CREATEDDATE: "01 Sep 2024",
  },
  {
    key: "11",
    IMAGE: "customer-02.jpg",
    CUSTOMER: "Jean Walker",
    RATING: "(3.0)",
    REVIEW: "Perfect for our family getaway!",
    CREATEDDATE: "15 Aug 2024",
  },
];
